module.exports = flarum.core.compat['forum/components/NotificationList'];